import api from './api';
import { LoginCredentials, RegisterData, User } from '../types/auth';

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<{ user: User; token: string }> => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  sendCode: async (email: string): Promise<{ ok: boolean; message: string }> => {
    const response = await api.post('/auth/send-code', { email });
    return response.data;
  },

  registerPublic: async (data: { username: string; name: string; email: string; phone?: string; password: string; code: string }): Promise<{ user: User; token: string }> => {
    const response = await api.post('/auth/register-public', data);
    return response.data;
  },

  register: async (data: RegisterData): Promise<{ user: User; token: string }> => {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  getProfile: async (): Promise<User> => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  updateProfile: async (data: Partial<User>): Promise<User> => {
    const response = await api.put('/auth/profile', data);
    return response.data;
  },

  changePassword: async (oldPassword: string, newPassword: string): Promise<void> => {
    await api.patch('/auth/password', { oldPassword, newPassword });
  },
};
